import { render, staticRenderFns } from "./MyOrderList.vue?vue&type=template&id=90362f8a&scoped=true"
import script from "./MyOrderList.vue?vue&type=script&lang=js"
export * from "./MyOrderList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90362f8a",
  null
  
)

export default component.exports